import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import LocalizedMessage from '../../../components/LocalizedMessage';
import classes from './NotFound.module.scss';

class NotFound extends Component {
  render () {
    return (
      <div className={classes.Container}>
        <LocalizedMessage
          id='site.title.notFound'
        >
          {localizedMessage => (
            <Helmet
              title={localizedMessage}
            />
          )}
        </LocalizedMessage>
        <div className={classes.Round}>
          <p className={classes.Description}>
            <LocalizedMessage
              id='404.notYourPage'
            />
          </p>
          <h1 className={classes.Title}>
            404
          </h1>
          <h2 className={classes.SubTitle}>
            <LocalizedMessage
              id='404.pageNotFound'
            />
          </h2>
        </div>
      </div>
    );
  }
}

export default NotFound;
